import React, {Component} from 'react';
import {
	Button,
	Link,
	Select,
	SelectItem,
	Slider,
	Tabs,
	Tab,
} from 'carbon-components-react';
import { Renew16 } from '@carbon/icons-react';

import PropertyComponent from '../../components/PropertyComponent';
import CCSlider from '../../components/CCSlider';
import ParameterSlider from '../../components/ParameterSlider';
import ParameterToggle from '../../components/ParameterToggle';
import { IndexedParameterSelect, IndexedParameterValue } from '../../components/IndexedParameterSelect';
import LoggingToggle from '../../components/LoggingToggle';
import MidiDevicesDialogWrapper from '../../components/MidiDevicesDialogWrapper';
import NoteDivisionParameterSelect from '../../components/NoteDivisionParameterSelect';
import DevicePropertyButton from '../../components/DevicePropertyButton';
import DevicePropertySelect from '../../components/DevicePropertySelect';
import DevicePropertyToggle from '../../components/DevicePropertyToggle';
import PresetGrid from '../../components/PresetGrid';
import {
	FirmwareVersionField,
	ErrorCodeField,
	PSUVoltageField,
	MidiChannelSelector
} from '../../components/ConfigSettings';

import * as midi from '../../js/rpl_midi.js';

midi.setProductId(0x01, 0x04, 'Raster');
midi.initialize();

class ExprDestinationSelector extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return (
	  				<Select value={this.state.value} labelText="" defaultValue="Dest..." onChange={this.handleChange}>
					  <SelectItem value="0" text="Off"/>
					  <SelectItem value="1" text="Blend"/>
					  <SelectItem value="2" text="Blend L/R"/>
					  <SelectItem value="3" text="Delay"/>
					  <SelectItem value="4" text="Delay L/R"/>
					  <SelectItem value="5" text="Feedback"/>
					  <SelectItem value="6" text="Feedback L/R"/>
					  <SelectItem value="7" text="Tone"/>
					  <SelectItem value="8" text="Mod Rate"/>
					  <SelectItem value="9" text="Mod Phase L/R"/>
					  <SelectItem value="10" text="Mod Depth"/>
					  <SelectItem value="11" text="Mod Depth L/R"/>
					  <SelectItem value="12" text="Shift"/>
					  <SelectItem value="13" text="Shift L/R"/>
	  				</Select>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setIndexedParameterValue(this.propId, newValue);
	}

	setValue(x) {
		this.setState({value : x});
	}
}

class ExprSlider extends PropertyComponent {

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	render() {
		return <Slider min="0" max="100" step="0.1" stepMultiplier="40" labelText={this.labelText} onChange={this.handleChange} value={this.state.value} disabled={this.state.disabled} hideTextInput="1"/>
	}

	handleChange(props) {
		var newValue = Number(props.value);
		this.setState({value: newValue});
		midi.setParameterValue(this.propId, newValue / 100);
	}

	handleControlChange(ccNum, ccValue) {
		this.setValue(ccValue / 127);
	}

	setValue(x) {
		// Because the property ID has bit 0x2000 set, rpl_midi does not
		// scale the value
		this.setState({value : 100 * x / 8388608.0});
	}
}

class ExprDestination extends React.Component {
	constructor(props) {
		super(props);

		this.destPropId = props.destPropId;
		this.minPropId  = props.minPropId;
		this.maxPropId  = props.maxPropId;
	}

	render() {
		return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-4 bx--col-md-5 bx--col-lg-4">
	  				<ExprDestinationSelector propId={this.destPropId}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ExprSlider labelText="" propId={this.minPropId}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ExprSlider labelText="" propId={this.maxPropId}/>
	  			  </div>
	  			</div>
		);
	}
}

class ExprDestinations extends React.Component {

	createDestinations() {
		var children = [];

		for (var i = 0; i < 6; i++) {
			children.push(<ExprDestination
							destPropId={midi.PROPERTY_EXPR_DEST_1 + 3*i}
							minPropId={midi.PROPERTY_EXPR_MIN_1 + 3*i}
							maxPropId={midi.PROPERTY_EXPR_MAX_1 + 3*i}
						  />
						);
		}

		return children;
	}

	render() {
		return (
			<div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-4 bx--col-md-5 bx--col-lg-4">
	  				Destination
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				Heel (Min)
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				Toe (Max)
	  			  </div>
	  			</div>
				{this.createDestinations()}
			</div>
		);
	}
}

class RemoteModeSelector extends PropertyComponent {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	createButtonAssignments() {
		if (this.state.value == 0) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 1<br/>DblT: Live<br/>Hold: Save</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 2<br/>DblT: Live<br/>Hold: Save</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 3<br/>DblT: Live<br/>Hold: Save</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset 4<br/>DblT: Live<br/>Hold: Save</div>
	  			</div>
			);
		} else if (this.state.value == 1) {
			return (
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Shift/Tap<br/>&nbsp;<br/>&nbsp;</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">On<br/>&nbsp;<br/>&nbsp;</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset -<br/>&nbsp;<br/>&nbsp;</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">Preset +<br/>&nbsp;<br/>&nbsp;</div>
	  			</div>
			);
		}
	}

	render() {
		return (
			<div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <Select labelText="Remote Mode" value={this.state.value} onChange={this.handleChange}>
	  				<SelectItem text="Mode 1 - Presets 1-4" value="0"/>
	  				<SelectItem text="Mode 2 - Shift/Tap | On | Preset - | Preset +" value="1"/>
	  			  </Select>
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">A</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">B</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">C</div>
	  			  <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">D</div>
	  			</div>
				{this.createButtonAssignments()}
			</div>
		);
	}

	handleChange(event) {
		var newValue = event.target.value;
		this.setState({value: newValue});
		midi.setDeviceProperty(this.propId, [newValue]);
	}

	setValue(x) {
		this.setState({value : x });
	}
}

const props = {
  exprSlider: {
	  hideTextInput: 1,
	  min: 0,
	  max: 100,
	  step: 0.1,
	  stepMultiplier: 40,
	  labelText: null,
  },
  tabs: {
    selected: 0,
    triggerHref: '#',
    role: 'navigation',
  },
  tab: {
    href: '#',
    role: 'presentation',
    tabIndex: 0,
  },
};

const EditorPage = () => {
  return (
    <div className="bx--grid bx--grid--full-width landing-page">
      <div className="bx--row editor-page__status">
        <div className="bx--col-sm-2 bx--col-md-2 bx--col-lg-4">
	  		Status:&nbsp;
	  	    <span id="device-status"></span>
	    </div>
        <div className="bx--col-sm-1 bx--col-md-2 bx--col-lg-4">
	      <Button
	        className="editor-page__statusbtn"
	        disabled={false}
	        hasIconOnly={false}
	        iconDescription="Refresh"
	        kind="primary"
	        onClick={function noRefCheck(){midi.findMIDIDevice()}}
	        onFocus={function noRefCheck(){}}
	        renderIcon={Renew16}
	        size="default"
	        tabIndex={0}
	        tooltipAlignment="center"
	        tooltipPosition="bottom"
	        type="button"
	      >Refresh</Button>
	    </div>
      </div>
      <div className="bx--row landing-page__r2">
	    <div className="bx--col bx--no-gutter">
	      <Tabs {...props.tabs}>
	        <Tab {...props.tab} label="Edit">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Shift" propId={6} ccNum={16}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Fdbk" propId={2} ccNum={20}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Delay" propId={1} ccNum={18}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Shift L/R" propId={21} ccNum={17}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Fdbk L/R" propId={18} ccNum={21}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Delay L/R" propId={17} ccNum={19}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Shift Mode" propId={8231} ccNum={104}>
	  				  <IndexedParameterValue value="0" text="Transpose"/>
	  				  <IndexedParameterValue value="1" text="Detune"/>
	  				  <IndexedParameterValue value="2" text="Freq Shift"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Feedback Mode" propId={8227} ccNum={106}>
	  				  <IndexedParameterValue value="0" text="Forward"/>
	  				  <IndexedParameterValue value="1" text="Forward / Shift Once"/>
	  				  <IndexedParameterValue value="2" text="Reverse"/>
	  				  <IndexedParameterValue value="3" text="Reverse / Shift Once"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Delay Range" propId={8224} ccNum={107}>
	  				  <IndexedParameterValue value="0" text="400 ms"/>
	  				  <IndexedParameterValue value="1" text="800 ms"/>
	  				  <IndexedParameterValue value="2" text="1600 ms"/>
	  				  <IndexedParameterValue value="3" text="3200 ms (1600 rev)"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Blend" propId={0} ccNum={14}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mod Rate" propId={4} ccNum={22}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mod Depth" propId={5} ccNum={24}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Blend L/R" propId={16} ccNum={15}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mod Phase L/R" propId={19} ccNum={23}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Mod Depth L/R" propId={20} ccNum={25}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterSlider labelText="Tone" propId={3} ccNum={26}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Mod Wave" propId={8228} ccNum={102}>
	  				  <IndexedParameterValue value="0" text="Sine"/>
	  				  <IndexedParameterValue value="1" text="Triangle"/>
	  				  <IndexedParameterValue value="2" text="Ramp Up"/>
	  				  <IndexedParameterValue value="3" text="Ramp Down"/>
	  				  <IndexedParameterValue value="4" text="Square"/>
	  				  <IndexedParameterValue value="5" text="Random Step"/>
	  				  <IndexedParameterValue value="6" text="Random"/>
	  				  <IndexedParameterValue value="7" text="Env +"/>
	  				  <IndexedParameterValue value="8" text="Env -"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<NoteDivisionParameterSelect labelText="Delay Note Div" range="fast" propId={8225} ccNum={108}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Structure" propId={8226} ccNum={105}>
	  					<IndexedParameterValue text="Parallel" value={0}/>
	  					<IndexedParameterValue text="Series" value={2}/>
	  					<IndexedParameterValue text="Ping Pong" value={1}/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Mod Dest" propId={8229} ccNum={103}>
	  				  <IndexedParameterValue value="0" text="Amplitude"/>
	  				  <IndexedParameterValue value="1" text="Shift"/>
	  				  <IndexedParameterValue value="2" text="Delay"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<NoteDivisionParameterSelect labelText="Mod Note Div" range="slow" propId={8230} ccNum={109}/>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Left Footswitch" propId={8233} ccNum={112}>
	  				  <IndexedParameterValue value="0" text="Shift Momentary"/>
	  				  <IndexedParameterValue value="1" text="Shift Latching"/>
	  				  <IndexedParameterValue value="2" text="Tap"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<ParameterToggle labelText="Feedback Invert" labelA="Off" labelB="Invert" propId={46}/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Right Footswitch" propId={8234} ccNum={113}>
	  				  <IndexedParameterValue value="0" text="Momentary"/>
	  				  <IndexedParameterValue value="1" text="Latching"/>
	  				  <IndexedParameterValue value="2" text="Mute Output"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			</div>

	  			<div className="bx--row editor-page__tab-edit">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Shift Left/Right" propId={8236} ccNum={114}>
	  				  <IndexedParameterValue value="0" text="Linked (tilt)"/>
	  				  <IndexedParameterValue value="1" text="Independent"/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  			{/*
	  				<ParameterToggle labelText="Infinite Repeat" labelA="Feedback" labelB="∞Repeat" propId={45}/>
	  			  */}
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  				<IndexedParameterSelect labelText="Trails" propId={8235} ccNum={111}>
	  					<IndexedParameterValue text="Off" value={0}/>
	  					<IndexedParameterValue text="On" value={1}/>
	  					<IndexedParameterValue text="Global" value={2}/>
	  				</IndexedParameterSelect>
	  			  </div>
	  			</div>

			  </div>
	        </Tab>
	        <Tab {...props.tab} label="Ctrl Port">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-ctrl">
	  			Click Save button at bottom of page to save configuration.
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	  				<DevicePropertySelect labelText="CTRL Port Mode" propId={midi.PROPERTY_CTRL_MODE}>
	  				  <SelectItem text="Off" value="0"/>
	  				  <SelectItem text="Expression" value="1"/>
	  				  <SelectItem text="Tap Tempo" value="2"/>
	  				  <SelectItem text="Remote" value="3"/>
	  				  <SelectItem text="MIDI In (TRS)" value="4"/>
	  				</DevicePropertySelect>
	  			  </div>
	  			  <div className="bx--col-sm-2 bx--col-md-4 bx--col-lg-8">
	  				<CCSlider labelText="Expression Pedal Position" ccNum={4}/>
	  			  </div>
	  			</div>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <h1>Expression</h1>
	  			</div>
	  			<ExprDestinations/>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <h1>Remote</h1>
	  			</div>
	  			<RemoteModeSelector propId={midi.PROPERTY_REMOTE_BANK}/>
	  			<div className="bx--row editor-page__tab-ctrl">
	  			  <div class="bx--btn-set">
	  				<DevicePropertyButton kind="secondary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[0]} refreshProps={true}>
	  				  Revert
	  				</DevicePropertyButton>
	  				<DevicePropertyButton kind="primary" propId={midi.PROPERTY_CTRL_SAVE_CONFIG} dataBytes={[1]}>
	  				  Save
	  				</DevicePropertyButton>
	  			  </div>
	  			</div>
	  		  </div>
	        </Tab>
	        <Tab {...props.tab} label="Preset">
	  		  <PresetGrid numProgs={128} liveProg={128}/>
	        </Tab>
	        <Tab {...props.tab} label="Config">
	  		  <div className="bx--grid bx--grid--no-gutter bx--grid--full-width">
	  			<div className="bx--row editor-page__tab-config">
	  			<FirmwareVersionField propId={midi.PROPERTY_FIRMWARE_VERSION}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			<PSUVoltageField propId={midi.PROPERTY_PSU_VOLTAGE}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			<ErrorCodeField propId={midi.PROPERTY_ERROR_CODE}/>
	  			</div>
	  			{/*
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="AUX Switch" propId={midi.PROPERTY_AUX_SWITCH_MODE}>
	  			    <SelectItem text="Tap" value="0"/>
	  			    <SelectItem text="Preset" value="1"/>
	  			    <SelectItem text="Preset Shift" value="2"/>
	  			    <SelectItem text="Modulation On/Off" value="3"/>
	  			    <SelectItem text="LFO Hold" value="4"/>
	  			    <SelectItem text="LFO Hold On/Off" value="5"/>
	  			  </DevicePropertySelect>
	  			</div>
				*/}
                <div className="bx--row editor-page__tab-config">
                  <DevicePropertySelect labelText="Max. Input Level" propId={midi.PROPERTY_MAX_INPUT_LEVEL}>
                    <SelectItem text="+12 dBu with -3 dB pad" value="5"/>
                    <SelectItem text="+8 dBu (default)" value="4"/>
                    <SelectItem text="+5 dBu" value="2"/>
                    <SelectItem text="+0.5 dBu" value="3"/>
                  </DevicePropertySelect>
                </div>
  	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Input/Output Configuration" propId={midi.PROPERTY_IO_CONFIG}>
	  			    <SelectItem text="Mono In / Mono Out" value="0"/>
	  			    <SelectItem text="Mono In / Stereo Out" value="1"/>
	  			    <SelectItem text="Stereo In / Stereo Out" value="2"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <DevicePropertySelect labelText="Bypass Mode" propId={midi.PROPERTY_BYPASS_MODE}>
	  			    <SelectItem text="Auto" value="0"/>
	  			    <SelectItem text="DSP" value="2"/>
	  			    <SelectItem text="Analog" value="1"/>
	  			    <SelectItem text="Analog + FX Level" value="4"/>
	  			    <SelectItem text="Kill Dry" value="3"/>
	  			  </DevicePropertySelect>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Trails" labelA="Off" labelB="Trails" propId={midi.PROPERTY_TRAILS}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  			  <MidiChannelSelector propId={midi.PROPERTY_MIDI_CHANNEL}/>
	  			</div>
	  			<div className="bx--row editor-page__tab-config">
	  				<DevicePropertyToggle labelText="Receive MIDI Clock" labelA="Off" labelB="On" propId={midi.PROPERTY_RECEIVE_MIDI_CLOCK}/>
	  			</div>
	  		  </div>
	        </Tab>
	        <Tab {...props.tab} label="Help">
			  <h3>Resources</h3>
  				<Link href="https://redpandalab.freshdesk.com/support/home">Knowledge Base</Link><br/>
				<Link href="http://www.redpandalab.com/downloads/">User Manuals and Firmware Updates</Link><br/>
				<Link href="http://www.redpandalab.com/contact/">Contact Us</Link><br/>

	  		  <h3>Expression Pedal</h3>
  				<p>To assign the expression pedal to any combination of knobs:
  				<ol>
  				  <li>1. Hold the right footswitch while pluggin in the expression pedal (right LED will blink orange 3x).</li>
  				  <li>2. Move expression pedal to the heel down position.</li>
  				  <li>3. Adjust knobs for the desired sound.</li>
  				  <li>4. Move expression pedal to the toe down position.</li>
  				  <li>5. Adjust knobs for the desired sound.</li>
  				  <li>6. Hold the right footswitch for 2 seconds to save (right LED will blink green).</li>
  				</ol>
  				</p>
	
  			  <h3>Limitations</h3>
				<ul>
  	  		  	  <li>The web editor does not reflect changes made by another MIDI device.
  	  			      Hit Refresh to update.</li>
				</ul>

			  <h3>Troubleshooting</h3>
	  		  <div className="bx--row editor-page__tab-help">
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  		        <MidiDevicesDialogWrapper/>
	  			  </div>
	  			  <div className="bx--col-sm-4 bx--col-md-4 bx--col-lg-5">
	  		        <LoggingToggle/>
	  			  </div>
	  		  </div>
	
	        </Tab>
	      </Tabs>
	    </div>
      </div>
      <div className="bx--row landing-page__r3">
      </div>
    </div>
  );
};

export default EditorPage;

